import { render, staticRenderFns } from "./SectionTextMiddle.vue?vue&type=template&id=2a70027e&scoped=true"
import script from "./SectionTextMiddle.vue?vue&type=script&lang=js"
export * from "./SectionTextMiddle.vue?vue&type=script&lang=js"
import style0 from "./SectionTextMiddle.vue?vue&type=style&index=0&id=2a70027e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70027e",
  null
  
)

export default component.exports